"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBrandSettingsEndpoint = exports.responseSchema = exports.payloadSchema = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const auth_1 = require("root/src/shared/constants/auth");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const recordTypes_1 = require("root/src/shared/descriptions/endpoints/recordTypes");
const setBrandSettingsPayloadSchema_1 = __importDefault(require("root/src/shared/descriptions/endpoints/schemas/requestSchemas/setBrandSettingsPayloadSchema"));
const setBrandSettingsResponseSchema_1 = __importDefault(require("root/src/shared/descriptions/endpoints/schemas/responseSchemas/setBrandSettingsResponseSchema"));
const middlewareIds_1 = require("root/src/shared/descriptions/middlewares/middlewareIds");
exports.payloadSchema = setBrandSettingsPayloadSchema_1.default;
exports.responseSchema = setBrandSettingsResponseSchema_1.default;
exports.setBrandSettingsEndpoint = {
    [endpointIds_1.SET_BRAND_SETTINGS]: {
        authentication: auth_1.authenticationTypes.authenticated,
        recordType: recordTypes_1.accountData,
        authenticationRole: auth_1.userGroups.brandUser,
        endpointType: lenses_1.userDataEndpointType,
        payloadSchema: exports.payloadSchema,
        responseSchema: exports.responseSchema,
        middlewares: [middlewareIds_1.VALIDATE_TOKEN_ACCOUNT],
    },
};
